import { BuilderPageContent, SymbolContent } from '../types'

export const getSymbolsBlockContentFromBuilderData = (
    data: BuilderPageContent,
    symbol: SymbolContent[]
) => {
    const resolvedBlocks = data?.blocks?.map(block => {
        // Check if the block is a Symbol component and has an entry ID
        if (
            block?.component?.name === 'Symbol' &&
            block?.component?.options?.symbol?.entry
        ) {
            const symbolId = block.component.options.symbol.entry
            const symbolData = symbol.find(symbol => symbol.id === symbolId) // Find the symbol by its ID
            return symbolData?.content?.data?.blocks?.[0] || block // Return the first block of the symbol, or the original block if not found
        }
        return block
    })
    return resolvedBlocks
}
